import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f258b1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "info_title" }
const _hoisted_4 = { class: "Template_head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Template_head_title" }, "基础资料", -1))
const _hoisted_7 = { class: "Template_head" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Template_head_title" }, "开票资料", -1))
const _hoisted_10 = { class: "info_body" }
const _hoisted_11 = { class: "body_left" }
const _hoisted_12 = { class: "body_right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b_line" }, null, -1))
const _hoisted_14 = { class: "info_title" }
const _hoisted_15 = { class: "Template_head" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Template_head_title" }, "关联信息", -1))
const _hoisted_18 = { class: "Template_head" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Template_head_title" }, "短信配置", -1))
const _hoisted_21 = { class: "info_body" }
const _hoisted_22 = { class: "body_left" }
const _hoisted_23 = { class: "body_right" }
const _hoisted_24 = {
  class: "dialog-footer",
  style: {"margin-top":"30px"}
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("确 定")

import { reactive, ref } from "vue";
import type { FormRules, FormInstance } from "element-plus";
import router from "@/router/index";
import { merchantadd, merchantgetOtherConfig, merchantupdate, merchantinfo } from "@/api/Merchantapi";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const routers = useRoute();

// console.log(data2, "父级传参");

const loading = ref(false);
const img = ref("/compontsimg/infoicon.png");
const img1 = ref("/compontsimg/infoicon2.png");
const img2 = ref("/compontsimg/infoicon3.png");
const img3 = ref("/compontsimg/infoicon4.png");
const ruleFormRef = ref<FormInstance>();
const ruleFormRefone = ref<FormInstance>();
// 手机号验证
// const storeNumRules = (rule: any, value: any, callback: any) => {
//   if (!value) {
//     return callback(new Error("请输入联系电话"));
//   }
//   setTimeout(() => {
//     var reg = /^1[3-9]\d{9}$/;
//     if (!reg.test(value)) {
//       callback(new Error("请输入正确的手机号码"));
//     }
//   }, 500);
// };
// 门店数量验证
// const Telrules = (rule: any, value: any, callback: any) => {
//   if (!value) {
//     return callback(new Error("请输入现有门店数量"));
//   }
//   setTimeout(() => {
//     let num = Number(value);

//     if (!Number.isInteger(num) || num <= 0) {
//       callback(new Error("请输入正确的数字"));
//     }
//   }, 500);
// };

const rules = reactive<FormRules>({
  merchantName: [{ required: true, message: "请输入输入商家名称", trigger: "blur" }],
  address: [{ required: true, message: "请输入商户地址", trigger: "blur" }],
  contactMobile: [
    { required: true, message: "请输入联系电话", trigger: "blur" },
    { min: 11, max: 11, message: "请输入11位的电话号码", trigger: "blur" },
  ],
  contactName: [{ required: true, message: "请输入联系人姓名", trigger: "blur" }],
  storeNum: [{ required: true, message: "请输入门店数量", trigger: "blur" }],
  // erpVersionCode: "",
  // id: 0,
  merchantSimpleName: [{ required: true, message: "请输入商户简称", trigger: "blur" }],
  merchantSimpleNameSpell: [{ required: true, message: "请输入商户简称的首拼字母", trigger: "blur" }],
});
const rules2 = reactive<FormRules>({
  erpVersion: [{ required: true, message: "请选择ERP版本", trigger: "change" }],
  userId: [{ required: true, message: "请选择销售负责人", trigger: "change" }],
});
const merchantErp = ref<Res.merchantgetOtherConfig>();
const merchantErpConfigDtos = ref<
  [
    {
      erpName: string;
      erpVersion: string;
      erpVersionCode: string;
    }
  ]
>([
  {
    erpName: "",
    erpVersion: "",
    erpVersionCode: "",
  },
]);
const merchantSalesDirectorDtos = ref<
  [
    {
      userAccount: string;
      userId: number;
      userRole: number;
      userName: string;
    }
  ]
>([
  {
    userAccount: "",
    userId: 1,
    userRole: 1,
    userName: "",
  },
]);
const getOtherConfig = () => {
  merchantgetOtherConfig().then((res) => {
    console.log(res);
    merchantErp.value = res.data;
    merchantErpConfigDtos.value = merchantErp.value.merchantErpConfigDtos;
    merchantSalesDirectorDtos.value = merchantErp.value.merchantSalesDirectorDtos;
    // console.log(merchantErp.value.merchantErpConfigDtos);
    // console.log(merchantErp.value.merchantSalesDirectorDtos);
  });
};

getOtherConfig();

const form = ref({
  area: "",
  businessImg: "",
  city: "",
  address: "",
  addressAndPhone: "",
  companyName: "",
  contactMobile: "",
  contactName: "",
  corporateAccount: "",
  depositBank: "",
  erpVersion: "",
  erpVersionCode: "",
  id: "",
  merchantName: "",
  merchantSimpleName: "",
  merchantSimpleNameSpell: "",
  messageAccount: "",
  messagePassword: "",
  msgTitle:"",
  province: "",
  storeNum: "",
  taxpayerNumber: "",
  userId: "",
});

const merchantId = routers.query.id as any;
const infoFlag1 = ref(false);
const infoFlag2 = ref(false);
const infoFlag3 = ref(false);
const infoFlag4 = ref(false);
if (merchantId) {
  console.log(123456);

  merchantinfo({ merchantId }).then((res) => {
    if (res.code === 1) {
      console.log(res);
      form.value = res.data;
      if (form.value.messageAccount) {
        infoFlag1.value = true;
      }
      if (form.value.messagePassword) {
        infoFlag2.value = true;
      }
      if (form.value.msgTitle) {
        infoFlag4.value = true;
      }
      if (form.value.erpVersion) {
        infoFlag3.value = true;
      }
    }
  });
}

const merchant = reactive(form);

const gooleshow = ref(false);
// const commitFn = () => {
const iscommitFnone = ref(false);
const iscommitFntwo = ref(false);
const commitFnone = async (formElone: FormInstance | undefined) => {
  if (!formElone) return;
  await formElone.validate((valid, fields) => {
    if (valid) {
      // gooleshow.value = true;
      iscommitFnone.value = true;
    } else {
      // console.log("error submit!", fields);
      iscommitFnone.value = false;
    }
  });
  // console.log(1);
};

const commitFntwo = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      // gooleshow.value = true;
      iscommitFntwo.value = true;
    } else {
      // console.log("error submit!", fields);
      iscommitFntwo.value = false;
    }
  });
  // console.log(2);
};

const commitFn = async (ruleFormRefone: FormInstance | undefined, ruleFormRef: FormInstance | undefined) => {
  await commitFntwo(ruleFormRef);
  await commitFnone(ruleFormRefone);
  // console.log(3);
  if (iscommitFntwo.value && iscommitFnone.value) {
    gooleshow.value = true;
  }
};

// };

const ElMessagesucc = () => {
  ElMessage({
    message: "操作成功！",
    type: "success",
  });
};

const gooleId = ref("");
const onconfirm = (val: any) => {
  let gId = val.ruleForm.gooleId;
  gooleId.value = gId;
  if (gooleId.value == "") {
    return;
  }
  gooleshow.value = !gooleshow.value;
  loading.value = true;
  const data = reactive({ command: gooleId.value, merchant });

  if (form.value.id) {
    merchantupdate(data)
      .then((res) => {
        console.log(res);
        ElMessagesucc();
        loading.value = false;
        setTimeout(() => {
          cancelFn();
        }, 1000);
      })
      .catch(() => {
        loading.value = false;
      });
  } else {
    merchantadd(data)
      .then((res) => {
        console.log(res);
        ElMessagesucc();
        loading.value = false;
        setTimeout(() => {
          cancelFn();
        }, 1000);
      })
      .catch(() => {
        loading.value = false;
      });
  }

  gooleId.value = "";
};
const cancelFn = () => {
  router.go(-1);
};
const erpVersionCodeFn = (val: string) => {
  // console.log(val,'版本code');
  console.log(merchantErpConfigDtos.value);

  merchantErpConfigDtos.value.forEach((item) => {
    if (item.erpVersionCode == val) {
      form.value.erpVersionCode = item.erpVersionCode;
      form.value.erpVersion = item.erpVersion;
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Redprompt = _resolveComponent("Redprompt")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_GoogleDialogue = _resolveComponent("GoogleDialogue")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: img.value,
            alt: ""
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createVNode(_component_Redprompt, { text: "基础资料全部选项为必填选项" })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: img1.value,
            alt: ""
          }, null, 8, _hoisted_8),
          _hoisted_9,
          _createVNode(_component_Redprompt, { text: "开票资料可后续补录" })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRefone",
            ref: ruleFormRefone,
            model: form.value,
            "label-width": "100px",
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "商户名称",
                prop: "merchantName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.merchantName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.merchantName) = $event)),
                    maxlength: "20",
                    placeholder: "请输入商家名称（20字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "商户简称",
                prop: "merchantSimpleName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.merchantSimpleName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.merchantSimpleName) = $event)),
                    maxlength: "6",
                    placeholder: "请输入商户简称（6字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "简称首拼",
                prop: "merchantSimpleNameSpell"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.merchantSimpleNameSpell,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.merchantSimpleNameSpell) = $event)),
                    maxlength: "6",
                    oninput: "value=value.replace(/[^a-z]/g, '')",
                    placeholder: "请输入商户简称的首拼字母，如ssm（6字内,仅支持小写字母）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "商户地址",
                prop: "address"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.address,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.address) = $event)),
                    maxlength: "40",
                    placeholder: "请输入商户地址（40字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "联 系 人",
                prop: "contactName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.contactName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.contactName) = $event)),
                    maxlength: "10",
                    placeholder: "请输入联系人姓名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "联系电话",
                prop: "contactMobile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.contactMobile,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.contactMobile) = $event)),
                    maxlength: "11",
                    oninput: "value=value.replace(/[^\\d]/g,'')",
                    placeholder: "请输入联系人电话（仅限输入11位手机号码）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "已有门店",
                prop: "storeNum"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.storeNum,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.storeNum) = $event)),
                    onkeyup: "value=value.replace(/[^\\d]/g,'');",
                    placeholder: "请输入现有门店数量（仅限输入大于0的正整数）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_form, {
            ref: "form02",
            model: form.value,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "公司名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.companyName,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.companyName) = $event)),
                    maxlength: "60",
                    placeholder: "请输入开票公司名称（60字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "纳税人识别号",
                style: {"line-height":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.taxpayerNumber,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.taxpayerNumber) = $event)),
                    maxlength: "60",
                    placeholder: "请输入开票公司纳税人识别号（60字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "地址及电话" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.addressAndPhone,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.addressAndPhone) = $event)),
                    maxlength: "60",
                    placeholder: "请输入开票公司的开票地址和电话（60字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "开 户 行" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.depositBank,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.depositBank) = $event)),
                    maxlength: "60",
                    placeholder: "请输入开票公司的开户行名称（60字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "对公账号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.corporateAccount,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.corporateAccount) = $event)),
                    maxlength: "60",
                    placeholder: "请输入开票公司的对公账号（60字内）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("img", {
            src: img2.value,
            alt: ""
          }, null, 8, _hoisted_16),
          _hoisted_17,
          _createVNode(_component_Redprompt, { text: "关联ERP版本及业务负责人" })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            src: img3.value,
            alt: ""
          }, null, 8, _hoisted_19),
          _hoisted_20,
          _createVNode(_component_Redprompt, { text: "配置短信平台接口账号及密钥（提前联系开发人员配置，可上线前配置，配置后不可修改）" })
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: form.value,
            "label-width": "100px",
            rules: rules2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "ERP版本",
                prop: "erpVersion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.erpVersionCode,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.erpVersionCode) = $event)),
                    disabled: infoFlag3.value,
                    placeholder: "ERP版本",
                    onChange: erpVersionCodeFn
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(merchantErpConfigDtos.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.erpVersionCode,
                          label: item.erpName + item.erpVersion,
                          value: item.erpVersionCode
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "销售负责人",
                prop: "userId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: form.value.userId,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.userId) = $event)),
                    placeholder: "销售负责人"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(merchantSalesDirectorDtos.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: item.userName + '(' + item.userRole + ')' + item.userAccount,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_el_form, {
            ref: "form04",
            model: form.value,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "短信账号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.messageAccount,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.messageAccount) = $event)),
                    disabled: infoFlag1.value,
                    maxlength: "60",
                    placeholder: "请输入253短信平台的短信账号"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "短信密码",
                style: {"line-height":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.messagePassword,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.messagePassword) = $event)),
                    disabled: infoFlag2.value,
                    maxlength: "60",
                    placeholder: "请输入253短信平台的短信账号密码"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "短信签名",
                style: {"line-height":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.msgTitle,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.msgTitle) = $event)),
                    disabled: infoFlag4.value,
                    maxlength: "60",
                    placeholder: "请输入短信签名"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_el_button, { onClick: cancelFn }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          style: {"margin-left":"30px"},
          type: "primary",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (commitFn(ruleFormRef.value, ruleFormRefone.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_GoogleDialogue, {
        text: "",
        title: "谷歌动态口令",
        dialogVisible: gooleshow.value,
        "onUpdate:dialogVisible": _cache[18] || (_cache[18] = ($event: any) => ((gooleshow).value = $event)),
        onChangeNavfu: onconfirm
      }, null, 8, ["dialogVisible"])
    ])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})